import {Inject, LOCALE_ID, Pipe, PipeTransform} from '@angular/core';
import {PeriodDto} from '@api/utisha-backend';
import {TranslateService} from '@ngx-translate/core';

@Pipe({ name: 'datePeriod' })
export class DatePeriodPipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) private locale: string,
              private translate: TranslateService) {
  }

  transform(value: PeriodDto, format?: string): string {
    if (!value || !value.periods) {
      return '';
    }
    switch (value.unit) {
      case 'DAYS': return value.periods + ' ' +  this.translate.instant(value.periods > 1 ? 'date.days' : 'date.day');
      case 'WEEKS':  return value.periods + ' ' + this.translate.instant(value.periods > 1 ? 'date.weeks' : 'date.week');
      case 'MONTHS':  return value.periods + ' ' + this.translate.instant(value.periods > 1 ? 'date.months' : 'date.month');
      case 'YEARS':  return value.periods + ' ' + this.translate.instant(value.periods > 1 ? 'date.years' : 'date.year');
    }
    return '';
  }
}
